import React from "react";
import { StarIcon } from "lucide-react";
import { CAROUSEL_TESTIMONIALS } from "../data/content";
export function TestimonialCarousel() {
  return <div className="-mx-5" data-id="element-209" data-mp="2lq6959jg5fyg">
      <div className="flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4" style={{
      scrollbarWidth: "none"
    }} data-id="element-210" data-mp="2qnfxsmz0hnl8">
        {CAROUSEL_TESTIMONIALS.map((t, i) => <div key={i} className="w-[80%] shrink-0 snap-center rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.06] to-transparent p-5" data-id="element-211" data-mp="1xyitjnrmxrbh" data-mpi={i}>
            <div className="flex items-center gap-3" data-id="element-212" data-mp="22v98u8vm8ivu">
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#d4ff00] text-base font-extrabold text-black" data-id="element-213" data-mp="27vwwckkmyhlb">
                {t.name.charAt(0)}
              </div>
              <div data-id="element-214" data-mp="1f6ydtmclpdfh">
                <p className="text-sm font-bold text-white" data-id="element-215" data-mp="1f7hrgqv7xfnp">{t.name}</p>
                <p className="text-[12px] text-white/50" data-id="element-216" data-mp="1k62jw448av1l">
                  {t.age} años · {t.city}
                </p>
              </div>
            </div>
            <div className="mt-3 flex gap-0.5" data-id="element-217" data-mp="3435zs89pvnzb">
              {Array.from({
            length: 5
          }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-[#d4ff00] text-[#d4ff00]" data-id="element-218" data-mp="2ubi7y69904xb" data-mpi={s} />)}
            </div>
            <p className="mt-3 text-[13px] leading-relaxed text-white/80" data-id="element-219" data-mp="2pacgscv8kppw">
              {t.text}
            </p>
          </div>)}
      </div>
    </div>;
}